export default __webpack_public_path__ + "static/media/contact-phone.eea1062a.svg";